"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var isWeekdayIndex = exports.isWeekdayIndex = function isWeekdayIndex(value) {
  return [0, 1, 2, 3, 4, 5, 6].indexOf(value) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/utils/validators.js
// module id = 266
// module chunks = 0